import type { Node as ProsemirrorNode } from "prosemirror-model";

import { ProductTokenNode } from "@agent-ui/features/chat/components/chat-elements/message-input/ProductTokenNode";
import { serializeChatTokenPayload } from "@agent-ui/features/chat/utils/chatTokenSerialization";
import { mergeAttributes, Node } from "@tiptap/core";

interface MarkdownSerializerState {
  text: (text: string, escape?: boolean) => void;
}

export default Node.create({
  name: "productComponent",

  group: "inline",

  inline: true,

  selectable: false,
  atom: true,

  parseHTML() {
    return [
      {
        tag: "product-component",
      },
    ];
  },

  addAttributes() {
    return {
      data: {
        parseHTML: (element) => {
          const dataAttr = element.getAttribute("data");
          try {
            return dataAttr ? JSON.parse(dataAttr) : null;
          } catch {
            return null;
          }
        },
        renderHTML: (attributes) => {
          return {
            data: JSON.stringify(attributes.data),
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["product-component", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ProductTokenNode;
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: ProsemirrorNode) => {
          /*
           * NOTE (Kevin 2025-09-24): Persist product nodes as <chat-token> so the
           * markdown pipeline can round-trip them into ChatToken components when we
           * render history.
           */
          const token = serializeChatTokenPayload("product", node.attrs.data);
          if (token) {
            state.text(token, false);
          }
        },
      },
    };
  },
});
